import { render, staticRenderFns } from "./BidderLogin.vue?vue&type=template&id=20cd7e17&scoped=true&lang=pug"
import script from "./BidderLogin.vue?vue&type=script&lang=ts"
export * from "./BidderLogin.vue?vue&type=script&lang=ts"
import style0 from "./BidderLogin.vue?vue&type=style&index=0&id=20cd7e17&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cd7e17",
  null
  
)

export default component.exports